module.exports = __webpack_public_path__ + "img/insurance.02d5f510.png";